export default "__VITE_ASSET__DUmvOHxe__"